import { appConfig } from '@config/app.config';
import { ManagerBase } from '@core/ManagerBase';
import type { ILocalizationService } from '@core/interfaces';
import en from './locales/en.json';
import tr from './locales/tr.json';

type LocaleDictionary = Record<string, string>;

const localeFiles: Record<string, LocaleDictionary> = {
  tr,
  en,
};

/**
 * Merkezi yerelleştirme servisi.
 * Yeni dil eklemek için locales/ altına JSON dosyası eklenir.
 */
export class LocalizationService extends ManagerBase implements ILocalizationService {
  private locale: string = appConfig.defaultLocale;
  private dictionary: LocaleDictionary = localeFiles[appConfig.defaultLocale] ?? tr;

  get currentLocale(): string {
    return this.locale;
  }

  t(key: string, params?: Record<string, string | number>): string {
    const template = this.dictionary[key] ?? localeFiles[appConfig.fallbackLocale]?.[key] ?? key;

    if (!params) {
      return template;
    }

    return Object.entries(params).reduce(
      (result, [paramKey, value]) => result.replace(`{${paramKey}}`, String(value)),
      template,
    );
  }

  async setLocale(locale: string): Promise<void> {
    const resolvedLocale = locale in localeFiles ? locale : appConfig.fallbackLocale;
    this.locale = resolvedLocale;
    this.dictionary = localeFiles[resolvedLocale] ?? tr;
  }

  protected onInitialize(): void {
    // Phase 3: localStorage'dan kayıtlı locale okunacak.
  }

  protected onShutdown(): void {
    // no-op
  }
}
